import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Link,
  Divider,
  Stack,
} from "@mui/material";
import { useState } from "react";
import { deleteUser } from "../api/user/deleteUser"; // Adjust path if needed

import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import ChangePasswordDialog from "../component/ChangePasswordDialog";
import DeleteUserDialog from "../component/DeleteUserDialog";
import backIcon from "../icons/page_back.png";
import { red } from "@mui/material/colors";
const ProfilePage = () => {
  const userContext = useContext(AuthContext);
  const user = userContext.user || {};
  const navigate = useNavigate();
  const theme = useTheme();
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [openDeleteAcount, setOpenDeleteAcount] = useState(false);
  const [isConfirmOnly, setIsConfirmOnly] = useState(false);
  const [dialogState, setDialogState] = useState({
    title: "申請刪除帳號",
    content: "確認提出申請刪除帳號？",
  });
  const handleDialogState = (title, content) => {
    setDialogState({ title: title, content: content });
    setIsConfirmOnly(!isConfirmOnly)
  };
  const handleDeleteAcountClose = () => {
    setOpenDeleteAcount(false);
    setIsConfirmOnly(false);
    setDialogState({
      title: "申請刪除帳號",
      content: "確認提出申請刪除帳號？",
    });

  };
  const handleDeleteAcountOpen = () => {
    setOpenDeleteAcount(true);
  };
  const handleChangePasswordClose = () => {
    setOpenChangePassword(false);
  };
  const handleChangePasswordOpen = () => {
    setOpenChangePassword(true);
  };
  const handleBackButtonClick = () => {
    navigate("/app");
  };
  const handleDeleteUser = async (inputPassword) => {
    try {
      await deleteUser(user.Phone, inputPassword); // use password from dialog
      handleDialogState("申請刪除帳號", "");
      userContext.logout();
    } catch (err) {
      console.error("Delete failed", err);
      alert("刪除失敗，請稍後再試");
    }
  };
  
  
  return (
    <Box
      width="100%"
      height="100vh"
      sx={{ backgroundColor: theme.palette.background.default }}
    >
      <AppBar
        sx={{ bgcolor: theme.palette.appBar }}
        position="sticky"
        color="secondary"
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={backIcon}
            alt="back"
            sx={{ width: "50px", marginLeft: "-16px" }}
            onClick={handleBackButtonClick}
          />
          <Typography
            align="center"
            sx={{
              fontWeight: "bold",
              fontSize: "h6.fontSize",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            個人頁面
          </Typography>
        </Toolbar>
      </AppBar>
      {userContext.user === null ? (
        <Typography
          marginTop={20}
          fontSize={"h5.fontSize"}
          fontWeight={"bold"}
          align="center"
        >
          尚未登入
        </Typography>
      ) : (
        <Card sx={{ maxWidth: 400, margin: "auto", marginTop: 5 }}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginBottom: 2,
              }}
            >
              <Avatar sx={{ width: 80, height: 80, marginBottom: 1 }}></Avatar>
              <Typography fontSize={18} fontWeight={"bold"}>
                {user.Name}
              </Typography>
            </Box>
            <Divider></Divider>
            <Box marginTop={2}>
              <Typography fontSize={18} gutterBottom>
                手機號碼: {user.Phone}
              </Typography>
              <Stack
                direction={"row"}
                display={"flex"}
                justifyContent={"space-between"}
              >
                <Typography fontSize={18}>密碼: ********　</Typography>
                <Link
                  sx={{ color: theme.palette.text.blue, fontWeight: "bold" }}
                  onClick={handleChangePasswordOpen}
                >
                  變更密碼
                </Link>
              </Stack>
              <Divider sx={{ marginY: 3 }}></Divider>
              <Stack
                direction={"row"}
                display={"flex"}
                justifyContent={"center"}
              >
                <Link
                  sx={{
                    color: "#b71c1c",
                    fontWeight: "bold",
                    justifyContent: "center",
                  }}
                  onClick={handleDeleteAcountOpen}
                >
                  刪除帳號
                </Link> 
              </Stack>
            </Box>
          </CardContent>
        </Card>
      )}
      <DeleteUserDialog
  open={openDeleteAcount}
  onClose={handleDeleteAcountClose}
  onConfirm={() => handleDialogState("申請刪除帳號", "")}
  onDeleteUser={handleDeleteUser}
  confirmOnly={isConfirmOnly}
  title={dialogState.title}
  content={dialogState.content}
/>

      <ChangePasswordDialog
        handleChangePasswordClose={handleChangePasswordClose}
        open={openChangePassword}
      ></ChangePasswordDialog>
    </Box>
  );
};

export default ProfilePage;
